import { atom } from 'jotai';

const lzSCommonsFormErrorsAtom = atom<[] | null>([]);

export default lzSCommonsFormErrorsAtom;
